(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["reading-time"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('reading-time-component')) {
    /**
     * @typedef {Object} ReadingTimeState
     * @property {string} articleUrl - URL de l'article à analyser
     * @property {number} fallbackTime - Temps de fallback en minutes
     * @property {number} wordsPerMinute - Vitesse de lecture
     */
    class ReadingTimeComponent extends HTMLElement {
      // Cache partagé entre toutes les instances : un article n'est fetché qu'une
      // seule fois, même s'il apparaît dans plusieurs cartes.
      static cache = new Map();

      // Observer partagé : différer les fetch jusqu'à ce que la carte approche du
      // viewport, avec une marge pour anticiper le scroll.
      static observer = null;

      static getObserver() {
        if (!ReadingTimeComponent.observer) {
          ReadingTimeComponent.observer = new IntersectionObserver(
            (entries, observer) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  observer.unobserve(entry.target);
                  entry.target.calculateReadingTime();
                }
              });
            },
            { rootMargin: '200px' },
          );
        }
        return ReadingTimeComponent.observer;
      }

      constructor() {
        super();
        this.abortController = null;
      }

      /**
       * @returns {ReadingTimeState}
       */
      get config() {
        return {
          articleUrl: this.dataset.articleUrl,
          fallbackTime: parseInt(this.dataset.fallbackTime) || 1,
          wordsPerMinute: parseInt(this.dataset.wordsPerMinute) || 200,
        };
      }

      connectedCallback() {
        if (!this.config.articleUrl) return;

        // Résultat déjà en cache → affichage immédiat, pas de fetch.
        if (ReadingTimeComponent.cache.has(this.config.articleUrl)) {
          this.updateDisplay(ReadingTimeComponent.cache.get(this.config.articleUrl));
          return;
        }

        // Sinon on attend que la carte approche du viewport avant de fetcher.
        ReadingTimeComponent.getObserver().observe(this);
      }

      disconnectedCallback() {
        if (ReadingTimeComponent.observer) {
          ReadingTimeComponent.observer.unobserve(this);
        }
        if (this.abortController) {
          this.abortController.abort();
        }
      }

      /**
       * Calcule le temps de lecture depuis l'article distant.
       * @returns {Promise<void>}
       */
      async calculateReadingTime() {
        const { articleUrl, wordsPerMinute, fallbackTime } = this.config;

        // Double-check du cache (une autre instance a pu le remplir entre-temps).
        if (ReadingTimeComponent.cache.has(articleUrl)) {
          this.updateDisplay(ReadingTimeComponent.cache.get(articleUrl));
          return;
        }

        try {
          this.setLoadingState(true);
          this.abortController = new AbortController();

          const response = await fetch(articleUrl, {
            signal: this.abortController.signal,
            headers: { Accept: 'text/html' },
          });

          if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
          }

          const html = await response.text();
          const readingTime = this.extractAndCalculateReadingTime(html, wordsPerMinute);

          ReadingTimeComponent.cache.set(articleUrl, readingTime);
          this.updateDisplay(readingTime);
        } catch (error) {
          if (error.name !== 'AbortError') {
            this.handleError(fallbackTime);
          }
        } finally {
          this.setLoadingState(false);
          this.abortController = null;
        }
      }

      /**
       * Extrait et calcule le temps de lecture depuis le HTML de l'article.
       * @param {string} html - HTML de la page article
       * @param {number} wordsPerMinute - Vitesse de lecture
       * @returns {number} Temps en minutes
       */
      extractAndCalculateReadingTime(html, wordsPerMinute) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const mainArticle = doc.querySelector('.main-article');
        if (!mainArticle) {
          throw new Error('Main article content not found');
        }

        const textContent = mainArticle.textContent || '';
        const cleanText = textContent.replace(/\s+/g, ' ').trim();
        const wordCount = cleanText.split(' ').filter((word) => word.length > 0).length;

        return Math.max(1, Math.ceil(wordCount / wordsPerMinute));
      }

      /**
       * Met à jour l'affichage du temps.
       * @param {number} readingTime - Temps en minutes
       */
      updateDisplay(readingTime) {
        const timeElement = this.querySelector('[data-time]');
        if (timeElement) {
          timeElement.textContent = readingTime;
        }
      }

      /**
       * Affiche le fallback en cas d'erreur.
       * @param {number} fallbackTime - Temps de fallback
       */
      handleError(fallbackTime) {
        this.updateDisplay(fallbackTime);
      }

      /**
       * Bascule l'état de chargement (pilote le skeleton via `:empty`).
       * @param {boolean} loading - État de chargement
       */
      setLoadingState(loading) {
        this.toggleAttribute('data-loading', loading);
      }
    }

    customElements.define('reading-time-component', ReadingTimeComponent);
  }
  } catch(e) { console.error(e); }
})();

})();
